// action
import {
    SAVE_APPOINTMENT_FEEDBACK,
    SAVE_APPOINTMENT_FEEDBACK_FAIL,
    SAVE_APPOINTMENT_FEEDBACK_SUCCESS,
    SAVE_APPOINTMENT_FEEDBACK_RESET
} from '../action/saveAppointmentFeedbackAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "", 
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_APPOINTMENT_FEEDBACK:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_APPOINTMENT_FEEDBACK_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_APPOINTMENT_FEEDBACK_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_APPOINTMENT_FEEDBACK_RESET:
            return initialState
        default:
            return state
    }
}